module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"showMore":"View More"},"ar":{"showMore":"عرض المزيد"}}')
  delete Component.options._Ctor
}
